@if (categories$ | async; as categories) {
  <div
    class="sticky top-(--app-header-height) flex h-[calc(100vh-var(--app-header-height))] flex-col items-center gap-1 overflow-x-auto sm:static sm:top-auto sm:h-auto sm:w-full sm:flex-row sm:flex-wrap sm:justify-center">
    @for (category of categories; track category.name) {
      <a
        [relativeTo]="activatedRoute"
        [routerLinkActiveOptions]="{ exact: true }"
        [queryParams]="categoryQueryParam(category.name)"
        routerLink="."
        routerLinkActive="active">
        <p-button
          [text]="true"
          [label]="category.name"
          tabindex="-1"
          size="small"
          appPrimengButton />
      </a>
    }

    <a
      routerLink="."
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      [queryParams]="categoryQueryParam('all')"
      [relativeTo]="activatedRoute">
      <p-button
        [text]="true"
        label="A - Z"
        tabindex="-1"
        size="small"
        appPrimengButton />
    </a>
  </div>
} @else {
  <app-spinner-filled />
}
